export function arraysAreEqual(a: any[], b: any[]): boolean {
  if (a.length !== b.length) return false;
  return a.every((x, i) => {
    return areEqual(x, b[i]);
  });
}

export function areEqual(a: any, b: any) {
  if (a === b) return true;
  if (a === null || b === null) return false;
  const typeOfA = typeof a;
  const typeOfB = typeof b;
  if (typeOfA !== typeOfB) return false;
  if (Array.isArray(a) || Array.isArray(b)) {
    return false;
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    return arraysAreEqual(a, b);
  } else if (typeOfA === "object") {
    return objectsAreEqual(a, b);
  }
  return false;
}

export function objectsAreEqual(
  a: Record<string, any>,
  b: Record<string, any>,
): boolean {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (!arraysAreEqual(aKeys.sort(), bKeys.sort())) {
    return false;
  }
  return aKeys.every((k) => {
    return areEqual(a[k], b[k]);
  });
}
